module.exports = __webpack_public_path__ + "static/img/bg.7c102916.png";